import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

// Display metadata for the known report `type` values from GET /reports/options.
// Any type the backend adds later that isn't in this map still renders (via
// the DEFAULT_TYPE_META fallback) - the type list itself always comes from
// the API, this only controls how each one looks.
export const REPORT_TYPE_META = {
  INCOME: {
    label: "Income Report",
    description: "Revenue summary for the selected period",
    icon: TrendingUpOutlinedIcon,
  },
  PAYOUT: {
    label: "Payout Report",
    description: "Payouts disbursed for the selected period",
    icon: PaymentsOutlinedIcon,
  },
  SETTLEMENT: {
    label: "Settlement Report",
    description: "Settlement activity summary",
    icon: AccountBalanceOutlinedIcon,
  },
  DISPUTE: {
    label: "Dispute Report",
    description: "Disputes and chargebacks summary",
    icon: GavelOutlinedIcon,
  },
};

export const DEFAULT_TYPE_META = {
  label: "Report",
  description: "Generate a report for the selected period",
  icon: AssignmentOutlinedIcon,
};

export const getReportTypeMeta = (type) =>
  REPORT_TYPE_META[type] ?? { ...DEFAULT_TYPE_META, label: type ?? "Report" };

// Status colors for GET /reports/options `statuses`. Falls back to a neutral
// grey chip for any value not listed here.
export const REPORT_STATUS_META = {
  READY: { label: "Ready", color: "#16a34a", bg: "rgba(39,174,96,0.1)" },
  APPROVED: { label: "Approved", color: "#16a34a", bg: "rgba(39,174,96,0.1)" },
  SCHEDULED: { label: "Scheduled", color: "#d97706", bg: "rgba(245,158,11,0.1)" },
  AWAITING_APPROVAL: {
    label: "Awaiting Approval",
    color: "#7c3aed",
    bg: "rgba(124,58,237,0.1)",
  },
  GENERATING: { label: "Generating", color: "#2563eb", bg: "rgba(37,99,235,0.1)" },
  DECLINED: { label: "Declined", color: "#dc2626", bg: "rgba(220,38,38,0.1)" },
  FAILED: { label: "Failed", color: "#dc2626", bg: "rgba(220,38,38,0.1)" },
};

export const getReportStatusMeta = (status) =>
  REPORT_STATUS_META[status] ?? {
    label: status ?? "N/A",
    color: "text.secondary",
    bg: "rgba(0,0,0,0.06)",
  };

export const formatOptionLabel = (value) =>
  value
    ?.toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ") ?? value;

export const periods = [
  { id: "last_week", label: "Last Week" },
  { id: "last_month", label: "Last Month" },
  { id: "last_quarter", label: "Last Quarter" },
  { id: "custom", label: "Custom Period" },
];
